import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    login: builder.mutation({
      query: (body: { email: string; password: string }) => {
        return {
          url: "/user/app/login",
          method: "POST",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
      transformResponse: (response: any) => {
        return { ...response, data: { ...response?.data, deviceId } };
      },
    }),

    // Get Access Token
    getAccessToken: builder.mutation({
      query: (body) => {
        return {
          url: "/user/app/refresh",
          method: "POST",
          body,
        };
      },
    }),

    // Change Password
    changePassword: builder.mutation({
      query: (body) => {
        return {
          url: "/codioti/change-password",
          method: "PUT",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),
    // Change Password
    loginWithId: builder.mutation({
      query: (userId) => {
        return {
          url: `/user/${userId}/get-token`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useGetAccessTokenMutation,
  useChangePasswordMutation,
  useLoginWithIdMutation,
} = authApi;
